module.exports = __webpack_public_path__ + "img/DE06138.bb8eae88.png";